/**
 * Sanitizes privacy settings in modelOptions by keeping only enabled settings
 * and removing the privacy settings object entirely if no settings are enabled.
 *
 * @param {object} modelOptions - The model options object containing potential privacy settings
 * @returns {object} The modified modelOptions object
 */
function sanitizePrivacySettings(modelOptions) {
  if (
    modelOptions.privacySettings
    && (
      modelOptions.privacySettings.disableRecording
      || modelOptions.privacySettings.disableLogging
    )
  ) {
    modelOptions.privacySettings = {
      ...(modelOptions.privacySettings.disableRecording && { disableRecording: true }),
      ...(modelOptions.privacySettings.disableLogging && { disableLogging: true }),
    }
  }
  else {
    delete modelOptions.privacySettings
  }
  return modelOptions
}

export default sanitizePrivacySettings
